import React, { useState } from 'react';
import { Divider } from '@telus-uds/components-web';

import TabSelection from './tabSelection';
import ManagedITService from './managedITServices';
import MicrosoftLicensing from './microsoftLicensing';
import ManagedDetectionResponse from './managedDetectionResponse';

const FullyManaged = () => {
  const [selectedTab, setSelectedTab] = useState('MANAGED_IT_SERVICE');

  const tabComponents = {
    MANAGED_IT_SERVICE: <ManagedITService />,
    MICROSOFT_LICENSING: <MicrosoftLicensing />,
    MANAGED_DETECTION_RESPONSE: <ManagedDetectionResponse />,
  };

  return (
    <>
      <TabSelection selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <Divider space={2} variant={{ inverse: true }}/>
      {tabComponents[selectedTab] || <ManagedITService />}
    </>
  );
};

export default FullyManaged;
